<template>
  <div class="h-[300px] relative">
    <div class="absolute inset-0">
      <slot name="img"> </slot>
    </div>
    <div class="w-[1200px] mx-auto relative">
      <div class="absolute left-0 top-[70px] text-[#fff]">
        <p class="text-[42px] font-semibold">{{textcn}}</p>
        <p class="text-[16px]">{{texten}}</p>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'dg-banner',
  props: {
    textcn: {
      type: String,
      default: '',
    }, 
    texten: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {},
  mounted() { },
  created() { },
}
</script>
<style scoped></style>
